import { ReactNode } from "react";

import CopyFieldIcon from "components/CopyField/Icon";

import styles from "./styles.module.css";

type MarkdownAssistantPanelCodeBlockProps = {
  children: ReactNode;
  code: string;
};

const MarkdownAssistantPanelCodeBlock = ({
  children,
  code,
}: MarkdownAssistantPanelCodeBlockProps) => {
  return (
    <div className={styles.codeBlock}>
      <CopyFieldIcon title="Copy code" value={code} className={styles.copyButton} />
      <pre>{children}</pre>
    </div>
  );
};

export default MarkdownAssistantPanelCodeBlock;
